var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_4839_6285)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 4.90912C18.6021 4.90912 19.0905 5.39754 19.0905 6.00003L19.0917 7.14492C24.245 7.65714 28.3431 11.7556 28.8548 16.909L29.9996 16.9091C30.6021 16.9091 31.0905 17.3975 31.0905 18C31.0905 18.6025 30.6021 19.0909 29.9996 19.0909L28.8547 19.0921C28.3425 24.2451 24.2447 28.3429 19.0917 28.8551L19.0905 30C19.0905 30.6025 18.6021 31.0909 17.9996 31.0909C17.3971 31.0909 16.9087 30.6025 16.9087 30L16.9086 28.8552C11.7551 28.3435 7.65672 24.2454 7.14449 19.0921L5.9996 19.0909C5.39711 19.0909 4.90869 18.6025 4.90869 18C4.90869 17.3975 5.39711 16.9091 5.9996 16.9091L7.14438 16.909C7.65614 11.7552 11.7548 7.65657 16.9086 7.14481L16.9087 6.00003C16.9087 5.39754 17.3971 4.90912 17.9996 4.90912ZM19.0916 9.34041L19.0905 10.3637C19.0905 10.9662 18.6021 11.4546 17.9996 11.4546C17.3971 11.4546 16.9087 10.9662 16.9087 10.3637L16.9087 9.34027C12.961 9.83252 9.83209 12.9614 9.33984 16.9092L10.3632 16.9091C10.9657 16.9091 11.4541 17.3975 11.4541 18C11.4541 18.6025 10.9657 19.0909 10.3632 19.0909L9.33998 19.092C9.83267 23.0392 12.9614 26.1676 16.9087 26.6598L16.9087 25.6364C16.9087 25.0339 17.3971 24.5455 17.9996 24.5455C18.6021 24.5455 19.0905 25.0339 19.0905 25.6364L19.0916 26.6597C23.0384 26.167 26.1666 23.0388 26.6592 19.092L25.636 19.0909C25.0335 19.0909 24.5451 18.6025 24.5451 18C24.5451 17.3975 25.0335 16.9091 25.636 16.9091L26.6594 16.9092C26.1672 12.9618 23.0388 9.8331 19.0916 9.34041ZM17.9996 15.8182C19.2046 15.8182 20.1814 16.795 20.1814 18C20.1814 19.205 19.2046 20.1818 17.9996 20.1818C16.7946 20.1818 15.8178 19.205 15.8178 18C15.8178 16.795 16.7946 15.8182 17.9996 15.8182Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4839_6285",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.5addb9664afb2aadef988be42206e712.svg";
export { ForwardRef as ReactComponent };